import { VehicleBrands } from './../models/product/vehicleBrands';
import apiService from './apiService';
import commonService from 'utils/commonService';
import { LinkCategory } from 'constants/enums/linkCategory.enum';
import { BaseRes } from 'bff/models/base/baseRes';
import { Links, CarDoc, MotoDoc } from 'bff/models/link';
import { CodeClass } from 'constants/enums/codeClass.enum';
import {
  Codes,
  SysOption,
  Postcodes,
  EmailDomains,
  SysOptionReq,
  Activities,
  Activity,
  Inscats, Inscat
} from 'bff/models/info';
import { VehicleCars, VehicleType, VehicleReplacePrice, ValidVehiclePolicyPreiodReq, ValidVehiclePolicyPeriodRes, ValidLicenseReq, ValidLicenseRes, VehiclePlan, ValidVehicleType, ValidVehicleInsContentRes, ValidVehicleInsContentReq, ValidVehicleInsRuleRes, EvalCarReq, EvalCarRes, VehicleAdd, PaymentEBillReq, PaymentEBillRes, PaymentNccReq, PaymentNccRes, PdfExportContent, ApplyFormReq, ApplyForm, RenewalVehicle, CheckVehicleApplyTypeReq, CheckApplyType, VehiclePolicyNoReq, PolicyNo, ValidVehicleInsCommonRuleReq, ValidVehicleInsCommonRuleRes, ValidVehicleBlackListReq, ValidVehicleBlackListRes, CarSurveyNotify, Flows, PolicyVehiclePdvhpopt } from 'bff/models/product';
import { SysOptType } from 'constants/enums/sysOptType.enum';
import { SysOptions } from 'bff/models/info/sysoptions';
import { ReturnCode } from 'constants/enums/returnCode.enum';
import { VehicleItemList } from 'bff/models/product/vehicleItemList';
import { PaymentMethod } from 'bff/models/product/paymentMethod';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import { InsType } from 'constants/enums/insType.enum';
import { CodeId } from 'constants/enums/codeId.enum';
import _ from 'lodash';
import apiCommonService from 'bff/services/commonService';
import { InfoVehregdataReq, InfoVehregdataResp } from 'bff/models/info/infoVehregdata';

/**
 * @description 取得暫存的投保作業資料
*/
const fetchTempState = async () => {
  const res = await apiService.fetchInsureProcessCarTempState();
  return { ...res };
};

/**
 * @description 取得暫存的機車險投保作業資料
*/
const fetchTempMotoState = async () => {
  const res = await apiService.fetchInsureProcessMotoTempState();
  return { ...res };
};

/**
 * @description 取得 汽車險投保作業 初始化資料
*/
const fetchInitSetting = async (insTypeId: string) => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();
  const vehicleCatsReq = commonService.getApiReqData({ INS_TYPE_ID: insTypeId });
  const sysOptionReq: SysOptionReq = {
    PCLASS: [SysOptType.NATIONALITYV]
  };
  const vehicleLimitReq: SysOptionReq = {
    PCLASS: [SysOptType.VEHICLE]
  };
  const pNoFormatReq: SysOptionReq = {
    PCLASS: [SysOptType.PNO_FORMAT]
  };

  const sysOptionBaseReq = commonService.getApiReqData(sysOptionReq);

  const result = await Promise.all([
    apiService.fetchInscat(baseReq, reqConfig),
    apiService.fetchVehicleCats(vehicleCatsReq, reqConfig),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.UI),
    apiService.fetchSysOptions(sysOptionBaseReq, reqConfig),
    apiService.fetchSysOptions(commonService.getApiReqData(vehicleLimitReq), reqConfig),
    apiService.fetchSysOptions(commonService.getApiReqData(pNoFormatReq), reqConfig)
  ]).then(([inscatsRes, vehicleCatsRes, UICodeRes, sysOptRes, vehicleLimitRes, pNoRes]) => {
    const inscatsBaseRes:BaseRes<Inscats> = { ...inscatsRes };
    const inscatRes = _.find(inscatsBaseRes.TRANRS.INSURANCE_CATEGORY, (inscat:Inscat) => inscat.INS_TYPE_ID === insTypeId) as Inscat;
    const vehicleCatsBaseRes: BaseRes<VehicleCars> = { ...vehicleCatsRes };
    const UICodeBaseRes: BaseRes<Codes> = { ...UICodeRes };
    const sysOptBaseRes: BaseRes<SysOptions> = { ...sysOptRes };
    const vehicleLimitBaseRes: BaseRes<SysOptions> = { ...vehicleLimitRes }; // 車種限制

    // 回傳頁面所需資料
    const res = {
      inscat: { ...inscatRes },
      vehicleCars: commonService.arrayTypeReturn(vehicleCatsBaseRes.TRANRS.VEHICLE_CATEGORY),
      UICodes: commonService.arrayTypeReturn(UICodeBaseRes.TRANRS.CODES),
      nationalityVSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS[SysOptType.NATIONALITYV])),
      vehicleLimit: commonService.arrayTypeReturn(vehicleLimitBaseRes.TRANRS[SysOptType.VEHICLE]),
      pNoFormat: commonService.arrayTypeReturn(pNoRes.TRANRS[SysOptType.PNO_FORMAT])
    };

    return res;
  });

  return result;
};

/**
 * @description 取得 車主基本資料頁 初始化資料
*/
const fetchInitVehicleOwnerInfo = async (insTypeId: InsType) => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();
  const sysOptionReq = commonService.getApiReqData({
    PCLASS: [SysOptType.YESNO]
  });

  const result = await Promise.all([
    apiService.fetchLinkByCategory(baseReq, reqConfig, insTypeId === InsType.Car ? LinkCategory.CarDoc : LinkCategory.MotoDoc),
    apiService.fetchSysOptions(sysOptionReq, reqConfig),
    apiService.fetchFlowByInsTypeId(baseReq, reqConfig, InsType.Car),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.CARRM)
  ]).then(([docLinksRes, sysOptionRes, flowsRes, carrmCodeRes]) => {
    const docLinksBaseRes: BaseRes<Links<CarDoc | MotoDoc>> = { ...docLinksRes };
    const sysOptionBaseRes: BaseRes<SysOptions> = { ...sysOptionRes };
    const flowsBaseRes: BaseRes<Flows> = { ...flowsRes };
    const carrmCodeBaseRes: BaseRes<Codes> = { ...carrmCodeRes };
    const res = {
      docLinks: commonService.arrayTypeReturn(insTypeId === InsType.Car ? (docLinksBaseRes.TRANRS.LINKS as CarDoc)?.CARDOC : (docLinksBaseRes.TRANRS.LINKS as MotoDoc)?.MOTODOC),
      yesnoSysOpts: sysOptionBaseRes.TRANRS[SysOptType.YESNO].sort((first: SysOption, second: SysOption) => {
        if (first.PARAM_ORDER && second.PARAM_ORDER) return second.PARAM_ORDER - first.PARAM_ORDER;

        return 0;
      }),
      flows: commonService.arrayTypeReturn(flowsBaseRes.TRANRS.FLOWS),
      carrmCodes: commonService.arrayTypeReturn(carrmCodeBaseRes.TRANRS.CODES)
    };

    return res;
  });

  return result;
};

/**
 * @description 檢核保期(保發/關貿)
*/
const validVehiclePolicyPeriod = async (req: ValidVehiclePolicyPreiodReq) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.validVehiclePolicyPeriod(baseReq, reqConfig).then((res: BaseRes<ValidVehiclePolicyPeriodRes>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return { ...res.TRANRS };
  }
};

/**
 * @description 查詢續保件
*/
const renewalVehicle = async (insTypeId: string, memberId: string, licenseNum: string, applyNo: string | null) => {
  const baseReq = commonService.getApiReqData({ INS_TYPE_ID: insTypeId, MEMBER_ID: memberId, VEHICLE_PNO: licenseNum, APPLY_NO: applyNo });
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.renewVehicle(baseReq, reqConfig).then((res: BaseRes<RenewalVehicle>) => res);

  return res.TRANRS;
};

/**
 * @description 取得 車籍資料 初始化資料
*/
const fetchInitVehicalInfo = async (insTypeId: string) => {
  const baseReq = commonService.getApiReqData({ INS_TYPE_ID: insTypeId });
  const reqConfig = commonService.getReqConfig();
  const sysOptionReq: SysOptionReq = {
    PCLASS: [SysOptType.VEHICLEPOWER]
  };

  const sysOptionBaseReq = commonService.getApiReqData(sysOptionReq);

  const result = await Promise.all([
    apiService.fetchVehicleBrands(baseReq, reqConfig),
    apiService.fetchSysOptions(sysOptionBaseReq, reqConfig)
  ]).then(([vehicleBrandsRes, sysOptRes]) => {
    const vehicleBrandsBaseRes: BaseRes<VehicleBrands> = { ...vehicleBrandsRes };
    const sysOptBaseRes: BaseRes<SysOptions> = { ...sysOptRes };

    const res = {
      vehicleBrands: {
        VEHICLE_BRAND: commonService.arrayTypeReturn(vehicleBrandsBaseRes.TRANRS.VEHICLE_BRAND),
        HOT_CHOICE: vehicleBrandsBaseRes.TRANRS.HOT_CHOICE
      },
      vehiclePowerSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS[SysOptType.VEHICLEPOWER]))
    };

    return res;
  });

  return result;
};

/**
 * @description 取得車款及車型資料
 * @param insTypeId 險種代碼
 * @param brandVal 廠牌代碼
 * @param displacement 排氣量
*/
const fetchVehicleType = async (req: any) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.fetchVehicleType(baseReq, reqConfig, req.INS_TYPE_ID).then((res: BaseRes<VehicleType>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    if (res.MWHEADER.RETURNDESC.indexOf(':') !== -1) {
      const errorMsgs = res.MWHEADER.RETURNDESC.split(':');
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        title: errorMsgs[0],
        html: errorMsgs[errorMsgs.length - 1]
      });
    } else {
      commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
    }
  } else {
    return { ...res.TRANRS };
  }
};

/**
 * @description 查詢重置價格
 * @param insTypeId 險種代碼
 * @param typeCode 車型資料
*/
const fetchVehicleReplacePrice = async (insTypeId: string, typeCode: string[], voDate: string = '', manufactureDate: string = '') => {
  const baseReq = commonService.getApiReqData({ INS_TYPE_ID: insTypeId, TYPE_CODE: typeCode, VO_SDATE: voDate, MANUFACTURE: manufactureDate });
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.fetchVehicleReplacePrice(baseReq, reqConfig).then((res: BaseRes<VehicleReplacePrice>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    let title = '';
    let desc = res.MWHEADER.RETURNDESC;
    if (res.MWHEADER.RETURNDESC.indexOf(':') !== -1) {
      const strArray = res.MWHEADER.RETURNDESC.split(':');
      title = strArray[0];
      desc = strArray[1];
    }

    sweetAlertService.modal({
      icon: SweetAlertIcon.Info,
      title: title,
      html: desc
    });
  } else {
    return res.TRANRS.REPLACEMENT_PRICE;
  }
};

/**
 * @description 原始發照年月檢核
*/
const validLicense = async (req: ValidLicenseReq) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.validVehicleLicense(baseReq, reqConfig).then((res: BaseRes<ValidLicenseRes>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS;
  }
};

/**
 * @description 車型限制檢核
*/
const validVehicleType = async (typeCode: string[]) => {
  const baseReq = commonService.getApiReqData({ TYPE_CODE: typeCode });
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.validVehicleType(baseReq, reqConfig).then((res: BaseRes<ValidVehicleType>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS;
  }
};

/**
 * @description 查詢汽車排氣量選項
 */
const queryPolicyVehiclePdvhpopt = async (brandCode: string) => {
  const baseReq = commonService.getApiReqData({ BRAND_CODE: brandCode });
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.queryPolicyVehiclePdvhpopt(baseReq, reqConfig) as BaseRes<PolicyVehiclePdvhpopt>;

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS;
  }
};

/**
 * @description 取得 選擇方案及商品頁 初始化資料
*/
const fetchInitSelect = async (insTypeId: string, brandCode: string, vehicleId: string, idType: string, isEcarPlate: boolean = false) => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();
  const vehicleItemReq = commonService.getApiReqData({
    INS_TYPE_ID: insTypeId,
    BRAND_CODE: brandCode,
    VEHCAT_ID: vehicleId,
    ID_TYPE: idType,
    TYPE_CODE4: isEcarPlate ? '01' : '00'
  });

  const sysOptionReq: SysOptionReq = {
    PCLASS: [SysOptType.MOTOR_COPRD]
  };

  const sysOptionBaseReq = commonService.getApiReqData(sysOptionReq);

  const result = await Promise.all([
    apiService.fetchVehicleItemList(vehicleItemReq, reqConfig),
    apiService.fetchSysOptions(sysOptionBaseReq, reqConfig),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.EXTENMSG, CodeId.M020)
  ]).then(([vehicleItemListRes, sysOptionRes, extenMsgRes]) => {
    const vehicleItemListBaseRes: BaseRes<VehicleItemList> = { ...vehicleItemListRes };
    const sysOptionBaseRes: BaseRes<SysOptions> = { ...sysOptionRes };
    const extenCodeBaseRes: BaseRes<Codes> = { ...extenMsgRes };

    const res = {
      vehicleItemList: vehicleItemListBaseRes.TRANRS,
      motoCoprdSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptionBaseRes.TRANRS[SysOptType.MOTOR_COPRD])),
      extenCodes: commonService.arrayTypeReturn(extenCodeBaseRes.TRANRS.CODES)
    };

    return res;
  });

  return result;
};

/**
 * @description 取得 選擇方案及商品頁 初始化資料 (適用於電動車方案)
 */
const fetchInitSelectForEcar = async (insTypeId: string) => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();
  const sysOptionReq: SysOptionReq = { PCLASS: [SysOptType.MOTOR_COPRD] };
  const sysOptionBaseReq = commonService.getApiReqData(sysOptionReq);

  const result = await Promise.all([
    apiService.fetchSysOptions(sysOptionBaseReq, reqConfig),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.EXTENMSG, CodeId.M020)
  ]).then(([sysOptionRes, extenMsgRes]) => {
    const vehicleItemListDefaultValue: VehicleItemList = { INS_TYPE_ID: insTypeId, POLICY_ITEM: [] };
    const sysOptionBaseRes: BaseRes<SysOptions> = { ...sysOptionRes };
    const extenCodeBaseRes: BaseRes<Codes> = { ...extenMsgRes };
    const res = {
      vehicleItemList: vehicleItemListDefaultValue,
      motoCoprdSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptionBaseRes.TRANRS[SysOptType.MOTOR_COPRD])),
      extenCodes: commonService.arrayTypeReturn(extenCodeBaseRes.TRANRS.CODES)
    };
    return res;
  });

  return result;
};

/**
 * @description 查詢車險方案(含保障內容)
*/
const fetchVehiclePlan = async (insTypeId: string, brandCode: string, idType: string, typeCode1: string, vehicleId: string, isEcarPlate: boolean = false) => {
  const reqConfig = commonService.getReqConfig();
  const vehicleItemReq = commonService.getApiReqData({
    INS_TYPE_ID: insTypeId,
    BRAND_CODE: brandCode,
    ID_TYPE: idType,
    TYPE_CODE1: typeCode1,
    VEHCAT_ID: vehicleId,
    TYPE_CODE4: isEcarPlate ? '01' : '00'
  });

  const res = await apiService.fetchVehiclePlan(vehicleItemReq, reqConfig).then((res: BaseRes<VehiclePlan>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    sweetAlertService.modal({
      icon: SweetAlertIcon.Info,
      html: `${res.MWHEADER.RETURNDESC}<br />(code : ${res.MWHEADER.RETURNCODE})`
    });
  } else {
    return res.TRANRS;
  }
};

/**
 * @description 檢核車險保障內容
*/
const validVehicleInsContent = async (req: ValidVehicleInsContentReq) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.validVehicleInsContent(baseReq, reqConfig).then((res: BaseRes<ValidVehicleInsContentRes>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    if (res.TRANRS && res.TRANRS.FAIL_ITEMS) {
      return res.TRANRS;
    }

    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS;
  }
  // if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
  //   commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  // } else {
  //   return res.TRANRS.FAIL_ITEMS;
  // }
};

/**
 * @description 車險保單規則檢核
*/
const validVehicleInsRule = async (req: ValidVehicleInsContentReq) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.validVehicleInsRule(baseReq, reqConfig).then((res: BaseRes<ValidVehicleInsRuleRes>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    if (res.TRANRS && (Object.keys(res.TRANRS).indexOf('FORCE_BCTYPE_B') !== -1 || Object.keys(res.TRANRS).indexOf('FORCE_BCTYPE_C') !== -1)) {
      return res.TRANRS;
    }

    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS;
  }
};

/**
 * @description 車險保費試算
*/
const evalCar = async (req: EvalCarReq, insTypeId: string) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.evalCar(baseReq, reqConfig, insTypeId).then((res: BaseRes<EvalCarRes>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    const result = await commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);

    if (res.MWHEADER.RETURNCODE === ReturnCode.ModelCodeError && result && result.value) {
      res.TRANRS.IS_MODEL_CODE_ERROR = true;
      return res.TRANRS;
    }
  } else {
    return res.TRANRS;
  }
};

/**
 * @description 車險網要網投判斷
*/
const validApplyType = async (req: CheckVehicleApplyTypeReq) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.validVehicleApplyType(baseReq, reqConfig).then((res: BaseRes<CheckApplyType>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS;
  }
};

/**
 * @description 取得要投保單號
*/
const fetchVehiclePolicyNo = async (req: VehiclePolicyNoReq) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.fetchVehiclePolicyNo(baseReq, reqConfig).then((res: BaseRes<PolicyNo>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS.SERIALNO;
  }
};

/**
 * @description 取得 資料填寫頁 初始化資料
*/
const fetchInitFill = async (insTypeId: InsType) => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();
  const sysOptionReq: SysOptionReq = {
    PCLASS: [SysOptType.RELATIONL, SysOptType.RELATIONV, SysOptType.MARRIAGE]
  };

  const sysOptionBaseReq = commonService.getApiReqData(sysOptionReq);
  const policyDeliverySysOpts = await apiCommonService.getDeliveryMethods(insTypeId) ?? [];

  const result = Promise.all([
    apiService.fetchPostcode(baseReq, reqConfig),
    apiService.fetchEmailDN(baseReq, reqConfig),
    apiService.fetchSysOptions(sysOptionBaseReq, reqConfig),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.POL_VAL)
  ]).then(([postcodesRes, emailDNsRes, sysOptRes, polValCodeRes]) => {
    const postcodesBaseRes: BaseRes<Postcodes> = { ...postcodesRes };
    const emailDNsBaseRes: BaseRes<EmailDomains> = { ...emailDNsRes };
    const sysOptBaseRes: BaseRes<SysOptions> = { ...sysOptRes };
    const polValCodeBaseRes: BaseRes<Codes> = { ...polValCodeRes };

    const res = {
      postcodes: commonService.arrayTypeReturn(postcodesBaseRes.TRANRS.POSTCODE),
      emailDomains: commonService.arrayTypeReturn(emailDNsBaseRes.TRANRS.EMAILDN),
      policyDeliverySysOpts: policyDeliverySysOpts,
      relationLSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS[SysOptType.RELATIONL])),
      relationVSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS[SysOptType.RELATIONV])),
      marriageSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS[SysOptType.MARRIAGE])),
      polValCodes: commonService.arrayTypeReturn(polValCodeBaseRes.TRANRS.CODES)
    };

    return res;
  });

  return result;
};

/**
 * @description 車險保單共通規則檢核
*/
const validInsCommonRule = async (req: ValidVehicleInsCommonRuleReq) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.validVehicleInsCommonRule(baseReq, reqConfig).then((res: BaseRes<ValidVehicleInsCommonRuleRes>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    if (res.TRANRS && res.TRANRS.COMMONCHECK && (res.TRANRS.FAIL || res.TRANRS.SUCCESS)) {
      return res.TRANRS;
    }

    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS;
  }
};

/**
 * @description 車險黑名單檢查
 */
const validVehicleBlackList = async (req: ValidVehicleBlackListReq) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();
  const res = await apiService.validVehicleBlackList(baseReq, reqConfig).then((res: BaseRes<ValidVehicleBlackListRes>) => res);
  // if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
  //   if (res.TRANRS && res.TRANRS.COMMONCHECK && (res.TRANRS.FAIL || res.TRANRS.SUCCESS)) {
  //     return res.TRANRS;
  //   }
  //   commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  // } else {
  //   return res.TRANRS;
  // }
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS;
  }
};

/**
 * @description 取得資料預覽頁條款資料
*/
const fetchDocLinks = async (insTypeId: string) => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();
  const linkCategory = insTypeId === InsType.Car ? LinkCategory.I02TERMS2 : LinkCategory.I03TERMS2;

  const res = await apiService.fetchLinkByCategory(baseReq, reqConfig, linkCategory).then((res: BaseRes<Links<any>>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return commonService.arrayTypeReturn(res.TRANRS.LINKS[linkCategory]);
  }
};

/**
 * @description 新增車險保單資料
*/
const addVehicle = async (req: VehicleAdd) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.addVehicle(baseReq, reqConfig).then((res: BaseRes<any>) => res);

  switch (res.MWHEADER.RETURNCODE) {
    case ReturnCode.CodeSuccess:
    case ReturnCode.CodePassApplyNo:
      return res.MWHEADER.RETURNDESC;
    default:
      commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE, '新增保單資料失敗');
      break;
  }
  // if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
  //   commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  // } else {
  //   return res.TRANRS;
  // }
};

/**
 * @description 取得 確認付款頁 初始化資料
 * @param serialNo 要保號
*/
const fetchInitPayment = async (serialNo: string, insTypeId: string) => {
  // console.log('fetchInitPayment serialNo', serialNo);
  const baseReq = commonService.getApiReqData({ APPLY_NO: serialNo, INS_TYPE_ID: insTypeId });
  const reqConfig = commonService.getReqConfig();

  const sysOptionReq: SysOptionReq = {
    PCLASS: [SysOptType.INSROLETYPE]
  };
  // console.log('fetchInitPayment', baseReq);
  const sysOptionBaseReq = commonService.getApiReqData(sysOptionReq);

  const result = await Promise.all([
    apiService.fetchPaymentMethod(baseReq, reqConfig),
    apiService.fetchSysOptions(sysOptionBaseReq, reqConfig),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.BARCODE_NOTE),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.BARCODE_NOTICE)
  ]).then(([paymentMethodRes, sysOptRes, barcodeNoteCodeRes, barcodeNoticeCodeRes]) => {
    const paymentBaseRes: BaseRes<PaymentMethod> = { ...paymentMethodRes };
    const sysOptBaseRes: BaseRes<SysOptions> = { ...sysOptRes };
    const barcodeNoteCodeBaseRes: BaseRes<Codes> = { ...barcodeNoteCodeRes };
    const barcodeNoticeCodeBaseRes: BaseRes<Codes> = { ...barcodeNoticeCodeRes };

    const res = {
      paymentMethod: { ...paymentBaseRes.TRANRS },
      insRoleTypeSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS[SysOptType.INSROLETYPE])),
      barcodeNoteCodes: commonService.arrayTypeReturn(barcodeNoteCodeBaseRes.TRANRS.CODES),
      barcodeNoticeCodes: commonService.arrayTypeReturn(barcodeNoticeCodeBaseRes.TRANRS.CODES)
    };

    return res;
  });

  return result;
};

/**
 * @description 執行線上付款-信用卡
*/
const paymentNccc = async (paymentNccReq: PaymentNccReq) => {
  const baseReq = commonService.getApiReqData(paymentNccReq);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.paymentNccc(baseReq, reqConfig).then((res: BaseRes<PaymentNccRes>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    const htmlStr = res.TRANRS && res.TRANRS.PAYMENT
      ? `${res.TRANRS.PAYMENT.RESPONSECODE} ${res.TRANRS.PAYMENT.RESPONSEMSG}`
      : `${res.MWHEADER.RETURNDESC}<br />(error code : ${res.MWHEADER.RETURNCODE})`;

    sweetAlertService.modal({
      icon: SweetAlertIcon.Info,
      html: htmlStr
    });
  } else {
    return res.MWHEADER.RETURNCODE;
  }
};

/**
 * @description 執行線上付款-活期帳戶
*/
const paymentEBill = async (paymentEBillReq: PaymentEBillReq) => {
  const baseReq = commonService.getApiReqData(paymentEBillReq);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.paymentEBill(baseReq, reqConfig).then((res: BaseRes<PaymentEBillRes>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    sweetAlertService.modal({
      icon: SweetAlertIcon.Info,
      html: `${res.MWHEADER.RETURNDESC}<br />(error code : ${res.MWHEADER.RETURNCODE})`
    });
  } else {
    return res.MWHEADER.RETURNCODE;
  }
};

/**
 * @description 取得投保完成頁，活動 Banner 資料
 * @param insTypeId 險種類別
*/
const fetchActivities = async (insTypeId: string) => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();

  const result = await Promise.all([
    apiService.fetchActivitiesByInsTypeId(baseReq, reqConfig, insTypeId)
    // apiService.fetchActivities(baseReq, reqConfig)
  ]).then(([activitiesRes]) => {
    const activitiesBaseRes: BaseRes<Activities> = { ...activitiesRes };

    const res = {
      activities: {
        MORE_ACTIVITY_URL: activitiesBaseRes.TRANRS.MORE_ACTIVITY_URL ? activitiesBaseRes.TRANRS.MORE_ACTIVITY_URL : '',
        ACTIVITY: activitiesBaseRes.TRANRS.ACTIVITY ? [...activitiesBaseRes.TRANRS.ACTIVITY.sort((first: Activity, second: Activity) => +first.SHOW_ORDER - +second.SHOW_ORDER)] : new Array(0)
      }
    };

    return res;
  });

  return result;
};

/**
 * @description 初始化 成功投保頁
*/
const fetchInitSuccess = async () => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();

  const sysOptionReq: SysOptionReq = {
    PCLASS: [SysOptType.EMAIL_NOTIFY, SysOptType.DOC_ID, SysOptType.PODELIVERY]
  };

  const sysOptionBaseReq = commonService.getApiReqData(sysOptionReq);

  const result = await Promise.all([
    apiService.fetchSysOptions(sysOptionBaseReq, reqConfig),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.INS_DONE_BAR),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.INS_DONE)
  ]).then(([sysOptRes, insDoneBarRes, insDoneRes]) => {
    const sysOptBaseRes: BaseRes<SysOptions> = { ...sysOptRes };
    const insDoneBaseRes: BaseRes<Codes> = { ...insDoneRes };
    const insDoneBarBaseRes: BaseRes<Codes> = { ...insDoneBarRes };
    const res = {
      emailNotifySysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS[SysOptType.EMAIL_NOTIFY])),
      docIdSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS[SysOptType.DOC_ID])),
      insDoneCode: commonService.arrayTypeReturn(insDoneBaseRes.TRANRS.CODES),
      insDoneBarCode: commonService.arrayTypeReturn(insDoneBarBaseRes.TRANRS.CODES),
      policyDeliverySysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS[SysOptType.PODELIVERY]))
    };

    return res;
  });

  return result;
};

/**
 * @description 文件套印
*/
const downloadApplyForm = async (applyFormReqContent: PdfExportContent) => {
  const applyFormReq: ApplyFormReq = {
    PDF_EXPORT: [applyFormReqContent]
  };

  const baseReq = commonService.getApiReqData(applyFormReq);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.downloadApplyForm(baseReq, reqConfig).then((res: BaseRes<ApplyForm>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE, '取得檔案位置失敗');
  } else {
    return res.TRANRS.FILE_URL;
  }
};

/**
 * @description 發送勘車簡訊 (未完成)
*/
const carSurveyNotify = async (req: CarSurveyNotify) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.carSurveyNotify(baseReq, reqConfig).then((res: BaseRes<any>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.MWHEADER.RETURNDESC;
  }
};

/**
 * @description 機車險-檢核會員生日是否正確
*/
const validMotoBirthday = async (req: any) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.validMotoBirthday(baseReq, reqConfig).then((res: BaseRes<any>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    // commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
    return res.MWHEADER.RETURNDESC;
  } else {
    return '';
  }
};

/**
 * @description 汽車險-檢核會員生日是否正確 (關貿)
 */
const validCarBirthday = async (req: any) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.validCarBirthday(baseReq, reqConfig).then((res: BaseRes<any>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    // commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
    return res.MWHEADER.RETURNDESC;
  } else {
    return '';
  }
};

/**
 * @description 取得繳費條碼頁面 URL
 */
const fetchBarcodeUrl = async (applyNo: string, payerName: string) => {
  const baseReq = commonService.getApiReqData({ APPLY_NO: applyNo, PAYER_NAME: payerName });
  const reqConfig = commonService.getReqConfig();
  // console.log('req', JSON.stringify(baseReq));
  const res = await apiService.fetchBarcodeUrl(baseReq, reqConfig).then((res: BaseRes<any>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS.BARCODE_URL;
  }
};

/**
 * @description 取得核心車籍資料
 * @param args 上行電文 TRANRQ 內容
 */
const infoVehregdata = async (args: InfoVehregdataReq) => {
  const baseReq = commonService.getApiReqData(args);
  const reqConfig = commonService.getReqConfig();
  const res = await apiService.infoVehregdata(baseReq, reqConfig).then((res: BaseRes<InfoVehregdataResp>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS.DATA;
  }
};


/**
 * @description 取得 特斯拉專屬方案開關 資料
*/
const fetchIsTeslaPlan = async (): Promise<string> => {
  const reqConfig = commonService.getReqConfig();
  const sysOptionReq: SysOptionReq = {
    PCLASS: [SysOptType.VEHICLE]
  };

  const sysOptionBaseReq = commonService.getApiReqData(sysOptionReq);

  try {
    // 1. 直接 await API，不需要 Promise.all (除非你有複數個 API 要同時跑)
    const sysOptRes = await apiService.fetchSysOptions(sysOptionBaseReq, reqConfig);
    
    // 2. 進行資料處理
    const sysOptBaseRes: BaseRes<SysOptions> = { ...sysOptRes };
    const vehicleOptions = commonService.arrayTypeReturn(sysOptBaseRes.TRANRS[SysOptType.VEHICLE]);

    // 3. 尋找目標值並直接回傳
    const targetValue = vehicleOptions.find(
      (opt: SysOption) => opt.PARAM_ID === 'TESLA_PLAN'
    )?.PARAM_VALUE;

    return targetValue || '';

  } catch (error) {
    return ''; // 發生錯誤時的 fallback
  }
};

export default {
  fetchTempState,
  fetchTempMotoState,
  fetchInitSetting,
  fetchInitVehicleOwnerInfo,
  validVehiclePolicyPeriod,
  renewalVehicle,
  fetchInitVehicalInfo,
  fetchVehicleType,
  fetchVehicleReplacePrice,
  validLicense,
  fetchInitSelect,
  fetchInitSelectForEcar,
  fetchVehiclePlan,
  validVehicleType,
  queryPolicyVehiclePdvhpopt,
  validVehicleInsContent,
  validVehicleInsRule,
  evalCar,
  fetchInitFill,
  validInsCommonRule,
  validVehicleBlackList,
  validApplyType,
  fetchVehiclePolicyNo,
  addVehicle,
  fetchDocLinks,
  fetchInitPayment,
  paymentNccc,
  paymentEBill,
  fetchActivities,
  fetchInitSuccess,
  downloadApplyForm,
  carSurveyNotify,
  validMotoBirthday,
  validCarBirthday,
  fetchBarcodeUrl,
  infoVehregdata,
  fetchIsTeslaPlan,
};
